(() => {
  if (window.ORJNDepartmentNavigation) return;
  window.ORJNDepartmentNavigation = true;
  // Do not rewrite supplier metadata. Missing gender on neutral adult accessories
  // (and socks) is a browse fallback, never an assumption about an unclassified garment.
  const genderMatches = (p, gender) => {
    if (p.ageRange) return false;
    const values = (Array.isArray(p.gender) ? p.gender : [p.gender])
      .flatMap(v => String(v || '').split(',')).map(v => v.trim().toLowerCase()).filter(Boolean);
    const neutral = values.includes('unisex') || (values.includes('men') && values.includes('women'));
    const fallback = !values.length && (String(p.productType || '').toLowerCase() === 'accessories' || p.clothingType === 'Socks');
    return neutral || fallback || values.includes(String(gender).toLowerCase());
  };
  window.ORJNDepartmentGenderMatches = genderMatches;
  const counts = new Map(), pending = new Map();
  const parse = a => {
    try {
      const u = new URL(a.getAttribute('href'), location.origin);
      const dept = u.pathname.match(/^\/collections\/(clothing|accessories)(?:\/|$)/)?.[1];
      if (!dept) return null;
      const genders = u.searchParams.getAll('filter.p.m.custom.gender');
      const gender = genders.find(v => v === 'Men' || v === 'Women');
      return {u, dept, gender, type: u.searchParams.get('filter.p.m.custom.clothing_type'), kids: u.searchParams.has('filter.p.m.custom.age_range')};
    } catch { return null; }
  };
  const summarize = products => {
    const types = new Map();
    for (const p of products) {
      if (!p.clothingType) continue;
      const c = types.get(p.clothingType) || {Men:0, Women:0, kids:0};
      if (genderMatches(p,'Men')) c.Men++;
      if (genderMatches(p,'Women')) c.Women++;
      if (p.ageRange) c.kids++;
      types.set(p.clothingType,c);
    }
    return types;
  };
  const feed = dept => {
    if (pending.has(dept)) return pending.get(dept);
    const promise = (async () => {
      const urlFor = page => {
        const u = new URL(`/collections/${dept}`, location.origin);
        u.searchParams.set('view','orjn-department-counts');u.searchParams.set('page',page);
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) u.searchParams.set('preview_theme_id',preview);
        return u;
      };
      const get = async page => {
        const response = await fetch(urlFor(page));
        if (!response.ok) throw Error('Department count feed '+response.status);
        const data = await response.json();
        if (!Array.isArray(data.products) || !Number.isFinite(data.total) || !Number.isFinite(data.pages)) throw Error('Incomplete count feed');
        return data;
      };
      const first = await get(1), chunks = [first];
      // Bounded, exact pagination; no speculative pages and no partial-count publication.
      for (let page=2;page<=first.pages;page+=4) {
        chunks.push(...await Promise.all(Array.from({length:Math.min(4,first.pages-page+1)},(_,i)=>get(page+i))));
      }
      const products = chunks.flatMap(c=>c.products);
      if (products.length !== first.total || chunks.some(c=>c.total!==first.total)) throw Error('Catalog changed during count read');
      return summarize(products);
    })();
    pending.set(dept,promise);
    promise.then(data=>{counts.set(dept,data);apply();}).catch(error=>{pending.delete(dept);console.warn('[ORJN department navigation]',error.message);});
    return promise;
  };
  const conceal = (node, empty) => { node.toggleAttribute('data-orjn-empty-category',empty);if (node.hidden!==empty) node.hidden=empty; };
  const apply = () => {
    // Header drawer + desktop menus + footer use the same live category/gender counts.
    document.querySelectorAll('a[href]').forEach(a=>{
      const x = parse(a);if(!x) return;
      if (x.gender && !x.u.searchParams.getAll('filter.p.m.custom.gender').includes('Unisex')) {
        x.u.searchParams.append('filter.p.m.custom.gender','Unisex');
        a.setAttribute('href',x.u.pathname+x.u.search+x.u.hash);
      }
      const data=counts.get(x.dept);if(!data || !x.type) return;
      const c=data.get(x.type);
      const n=x.kids ? (c?.kids||0) : x.gender ? (c?.[x.gender]||0) : (c?.Men||0)+(c?.Women||0);
      if(a.classList.contains('od__btn')) conceal(a,n===0);
      else if(a.closest('header-component')) conceal(a.closest('li')||a,n===0);
      else conceal(a,n===0);
    });
    document.querySelectorAll('[id^="OrjnDept-"]').forEach(root=>{
      const link=root.querySelector('.od__btn');const x=link&&parse(link);const data=x&&counts.get(x.dept);if(!data)return;
      let categories=0;
      root.querySelectorAll('.od__cell').forEach(cell=>{
        const a=cell.querySelector('.od__btn');const type=a&&parse(a)?.type;const c=data.get(type);const live=(c?.Men||0)+(c?.Women||0)>0;
        conceal(cell,!live);if(live)categories++;
        // Total products, not Men+Women sum: shared accessories must not be double-counted.
      });
      const label=root.querySelector('[data-live-dept-count]');
      if(label) {const total=label.textContent.match(/·\s*(\d+)\s*items/i)?.[1];const text=`${categories} categories${total ? ' · '+total+' items' : ''}`;if(label.textContent.trim()!==text)label.textContent=text;}
    });
    const header=document.querySelector('[data-orjn-department-header]');
    if(header){const type=new URLSearchParams(location.search).get('filter.p.m.custom.clothing_type');const title=header.querySelector('h1');if(type&&title&&title.textContent.trim()!==type+'.')title.textContent=type+'.';}
  };
  const start = () => {
    apply();
    const dept=location.pathname.match(/^\/collections\/(clothing|accessories)(?:\/|$)/)?.[1];
    if(dept)feed(dept);
    // Load the compact data when navigation is used elsewhere, without adding it to every page load.
    const nav=document.querySelector('header-component');
    const loadMenu=()=>{for(const d of ['clothing','accessories'])feed(d);};
    nav?.addEventListener('pointerover',loadMenu,{once:true});nav?.addEventListener('focusin',loadMenu,{once:true});nav?.addEventListener('click',loadMenu,{once:true});
    let queued=false;
    const observer=new MutationObserver(()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;apply();});});
    if(nav)observer.observe(nav,{childList:true,subtree:true});
    window.addEventListener('popstate',apply);
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
